export default "__VITE_ASSET__DZXvKZSy__"